export default __webpack_public_path__ + "static/media/level_active.16df180f.svg";